import React from 'react';
import ListItemText from '@material-ui/core/ListItemText';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import Popover from '@material-ui/core/Popover';
import ListItem from '@material-ui/core/ListItem';
import clsx from 'clsx';

export function SortOptionsDialog({
  filterKey,
  clinicianModal,
  filterValue,
  data,
  onChange,
  defaultValue,
  fullWidth = false,
  open,
  anchorEl,
  handleClose,
}) {
  const handleChange = e => {
    const selectedValue = e;
    if (selectedValue) onChange(filterKey, parseInt(selectedValue, 10));
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'right',
      }}
      onClose={handleClose}
    >
      <div className={clsx(clinicianModal)}>
        <Typography className="pop-up-header">Sort by</Typography>
        <List value={filterValue || defaultValue} fullWidth={fullWidth} className="list-items">
          {data &&
            data.map(({ name, id, label }) => (
              <ListItem className="small-text-items" button key={id} onClick={() => handleChange(id)}>
                <ListItemText primary={name} id={label} />
              </ListItem>
            ))}
        </List>
      </div>
    </Popover>
  );
}
